import React from 'react';
import classnames from 'classnames';
import { u as useInView_2 } from './useInView-CMTI-J0M.js';
import { A as Avatar } from './Avatar-IqiK7ixO.js';
import { I as Icon } from './Icon-8KKXFsxm.js';
import { u as useChildComponent } from './useChildComponent-DvxTpXTM.js';
import { T as Typography } from './Typography-BUVIUAC9.js';
import { T as Tooltip } from './Tooltip-B50E53VM.js';

var styles = {"chip":"af7U8MvcbHE-","prefix":"e905AYK4SCc-","suffix":"ySADfZ0FckM-","empty":"usdkmQ9Sxbk-","chipBar":"dg1-Izy1eQA-","selected":"-lz0EYLTDgg-","base":"wSI5L-5rODg-","invalid":"SmUxkzpIC84-","subtle":"Mux23dmZSuw-","disabled":"MbRItb9vKhc-","chipContent":"tJhURjR2Vec-","truncateGradient":"G3QXY0rNcK0-","chipLabelRef":"MUKEW6c2nNA-"};

function ChipPrefix({ children }) {
    const singleChild = useChildComponent(children, d => d.type === Avatar || d.type === Icon);
    return (React.createElement("span", { className: classnames(styles.prefix, !singleChild && styles.empty) }, singleChild));
}

function ChipSuffix({ children, className }) {
    var _a;
    let singleChild = useChildComponent(children, d => d.type === Icon);
    if (!allowedSuffixIcons.includes((_a = singleChild === null || singleChild === void 0 ? void 0 : singleChild.props) === null || _a === void 0 ? void 0 : _a.name)) {
        singleChild = undefined;
    }
    return (React.createElement("span", { className: classnames(styles.suffix, className, !singleChild && styles.empty) }, singleChild));
}
const allowedSuffixIcons = ["cross", "add", "checkmark", "arrowDown"];

const Chip = ({ ariaLabel, disabled, heading, invalid, label, value, onClick, onKeyDown, children, role = "button", tabIndex = 0, variation = "base", }) => {
    const classes = classnames(styles.chip, {
        [styles.invalid]: invalid,
        [styles.base]: variation === "base",
        [styles.subtle]: variation === "subtle",
        [styles.disabled]: disabled,
    });
    const prefix = useChildComponent(children, d => d.type === Chip.Prefix);
    const suffix = useChildComponent(children, d => d.type === Chip.Suffix);
    const [labelRef, labelFullyVisible] = useInView_2();
    const [headingRef, headingFullyVisible] = useInView_2();
    const tooltipMessage = getTooltipMessage(labelFullyVisible, headingFullyVisible, label, heading);
    return (React.createElement(Tooltip, { message: tooltipMessage },
        React.createElement("button", { className: classes, onClick: (ev) => onClick && onClick(value, ev), tabIndex: tabIndex, onKeyDown: onKeyDown, "aria-label": ariaLabel || label, disabled: disabled, role: role, type: "button" },
            prefix,
            React.createElement("div", { className: styles.chipContent },
                heading && (React.createElement(React.Fragment, null,
                    React.createElement(Typography, { size: "base", fontWeight: "medium" },
                        heading,
                        React.createElement("span", { ref: headingRef, className: styles.chipLabelRef })),
                    label && React.createElement("span", { className: styles.chipBar }))),
                React.createElement(Typography, { size: "base" },
                    label,
                    React.createElement("span", { ref: labelRef, className: styles.chipLabelRef })),
                !labelFullyVisible && (React.createElement("div", { className: styles.truncateGradient, "data-testid": "ATL-Chip-Truncation-Gradient" }))),
            suffix)));
};
function getTooltipMessage(labelFullyVisible, headingFullyVisible, label, heading) {
    let message = "";
    if (heading && !headingFullyVisible) {
        message = `${heading} | ${label}`;
    }
    else if (!labelFullyVisible) {
        message = label;
    }
    return message;
}
Chip.Prefix = ChipPrefix;
Chip.Suffix = ChipSuffix;

export { Chip as C, styles as s };
